<div *ngIf="isLoading">
  <app-loading></app-loading>
</div>
<div>
  <div class="header-section">
    <div class="header-content">
      <h1 class="scenarioTitle">Change Management Simulator</h1>
      <h2 class="scenarioSubtitle">List of scenarios</h2>
    </div>
    <button class="how-to-play-btn" (click)="openHowToPlayGuide()">
      How to play?
    </button>
  </div>

  <p class="results">
    Results {{ scenarios.length }} of {{ scenarios.length }}
  </p>

  <div style="flex-wrap: wrap; display: flex; gap: 16px">
    @for (scenario of scenarios; track scenario.id; let i = $index) {
    <div class="flex card" (click)="goToSimulator(scenario.id)">
      <div>
        <img
          [src]="'../../../assets/' + scenario.img"
          [alt]="scenario.img"
          class="scenario-placeholder-img"
        />
      </div>

      <div class="card-content">
        <h3 class="card-title">
          {{ scenario.name }}
        </h3>
        <p
          class="card-body"
          [innerHTML]="transformText(scenario.description)"
        ></p>
      </div>
    </div>
    }
  </div>
</div>
